import { version } from 'pdfjs-dist';

((window as unknown) as Record<string, string>)[`pdfWorkerSrc${version}`] =
  'assets/pdfjs/pdf.worker.min.mjs';
